import { IUsersTranslations } from '../';

const users: IUsersTranslations = {
  name: 'Nombre',
  users: 'Usuarios',
  email: 'Email',
  phone: 'Número de teléfono',
  deleteUsers: 'Destruir usuarios',
  delete_users_confirm: '¿Seguro que quieres eliminar definitivamente los usuarios seleccionados? Solo para cuentas sin actividad, como cuentas de prueba. Para solicitudes de protección de datos usa Borrar datos. Esta acción no se puede deshacer.',
  erase_action: 'Borrar datos (RGPD)',
  erase_title: 'Borrar los datos de esta cuenta',
  erase_hint: 'Úsalo para solicitudes de protección de datos. Una vez borrada:',
  erase_effect_locked_out: 'Ya no puede iniciar sesión y dejamos de contactarla. El email y el teléfono de acceso quedan libres para una nueva cuenta.',
  erase_effect_profile_removed: 'Se elimina el perfil (nombre, teléfono, fecha de nacimiento, ubicación, preferencias).',
  erase_effect_records_kept: 'Las compras, facturas, entradas e inscripciones a eventos se conservan para los organizadores y la contabilidad.',
  erase_checking: 'Comprobando si esta cuenta se puede borrar…',
  erase_check_failed: 'No se ha podido comprobar esta cuenta',
  erase_blocked_title: 'Esta cuenta aún no se puede borrar:',
  erase_blocker_is_staff: 'Las cuentas de staff no se pueden borrar.',
  erase_blocker_already_erased: 'Esta cuenta ya fue borrada.',
  erase_blocker_holds_upcoming_tickets: 'Tiene entradas para eventos que no han terminado. Deben transferirse a otra persona primero.',
  erase_blocker_sole_manager_of_upcoming_event: 'Es el único gestor de eventos que no han terminado. Añade otro gestor primero.',
  erase_ticket_refs: 'Entradas:',
  erase_event_refs: 'Eventos:',
  erase_recheck: 'Comprobar de nuevo',
  erase_reason: 'Motivo o referencia de la solicitud',
  erase_reason_placeholder: 'p. ej. ticket de soporte #1234',
  erase_confirm_label: 'Escribe el email del usuario para confirmar',
  erase_submit: 'Borrar cuenta',
  erase_success: 'Cuenta borrada',
  erase_failed: 'No se ha podido borrar esta cuenta',
};

export default users;
